<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width">
  @if (icon) {
    <mat-icon matPrefix>{{ icon }}</mat-icon>
  }
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }

  <input [id]="field + '-input'" matInput [formControlName]="field" [matAutocomplete]="auto" [required]="mandatory" />
  <span matSuffix class="suffix-actions">
    @if (searching) {
      <app-loader [formField]="true" [delay]="0"></app-loader>
    }
    @if (shouldDisplayClearBtn()) {
      <button mat-icon-button data-role="clear" (click)="resetControlValue($event)">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </span>
  @if (suffixButtonIcon) {
    <button mat-icon-button matSuffix data-role="suffix-btn" [disabled]="suffixButtonAction === null" (click)="suffixButtonAction()">
      <mat-icon>{{ suffixButtonIcon }}</mat-icon>
    </button>
  }

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="notifyListeners($event)">
    @for (o of options | async; track o) {
      <mat-option #optionElement [value]="o" [class]="field + '-list'">
        @if (displayTemplateRef) {
          <ng-container *ngTemplateOutlet="displayTemplateRef; context: { option: o }"></ng-container>
        } @else {
          @if (displayFn) {
            {{ displayFn(o) }}
          } @else {
            {{ o }}
          }
        }
      </mat-option>
    }
  </mat-autocomplete>

  <!-- The mat-error tag HAS to be directly inside the mat-form-field otherwise it doesn't render properly if inside the ng-container -->
  <mat-error>
    @for (e of errors; track e) {
      @if (formGroup.controls[field].hasError(e.error)) {
        <span [attr.data-form-field-error]="e.error">
          {{ e.messageKey | translate: formGroup.controls[field].getError(e.error) }}
        </span>
      }
    }
  </mat-error>

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
